import { api } from "./api";

let deferred = null;
const listeners = new Set();
const emit = () => listeners.forEach((f) => f());
const uid = () => { try { return JSON.parse(atob(localStorage.getItem("aa_token").split(".")[1])).sub; } catch (e) { return ""; } };
const NOTIFY_KEY = () => `aa_notify_${uid()}`;

export function initPwa() {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; emit(); });
}

export const onPwaChange = (f) => { listeners.add(f); return () => listeners.delete(f); };
export const canInstall = () => !!deferred;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const notifySupported = () => "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
export const notifyEnabled = () => notifySupported() && !!uid() && Notification.permission === "granted" && localStorage.getItem(NOTIFY_KEY()) === "1";

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  emit();
  return outcome === "accepted";
}

const toKey = (b64) => {
  const s = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(s, (c) => c.charCodeAt(0));
};

export async function enableNotifications() {
  if (!notifySupported()) return "unsupported";
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return perm;
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) }));
  await api.post("/me/push/subscribe", sub.toJSON());
  localStorage.setItem(NOTIFY_KEY(), "1");
  await api.post("/me/push/test");
  return "granted";
}

export async function disableNotifications() {
  localStorage.removeItem(NOTIFY_KEY());
  const reg = "serviceWorker" in navigator && (await navigator.serviceWorker.getRegistration());
  const sub = reg && reg.pushManager && (await reg.pushManager.getSubscription());
  if (sub) {
    await api.post("/me/push/unsubscribe", { endpoint: sub.endpoint });
    await sub.unsubscribe();
  }
}
